/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MailTemplateCustomerResource } from '../models/MailTemplateCustomerResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MailTemplateCustomerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les modeles d'e-mail personnalises
     * Les surcharges par entreprise des modeles d'e-mail (sujet, contenu, destinataires).
     * @returns MailTemplateCustomerResource Array of `MailTemplateCustomerResource`
     * @throws ApiError
     */
    public adminMailtemplatescustomerIndex(): CancelablePromise<Array<MailTemplateCustomerResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/mailtemplatescustomer',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Surcharger un modele d'e-mail pour une entreprise
     * `mail_template_id`, `customer_id`, `subject`, `content` obligatoires ; `to`, `carbon_copy`, `carbon_copy_invisible` optionnels. La surcharge remplace le modele par defaut pour cette entreprise.
     * @param requestBody
     * @returns MailTemplateCustomerResource `MailTemplateCustomerResource`
     * @throws ApiError
     */
    public adminMailtemplatescustomerStore(
        requestBody: {
            mail_template_id: number;
            customer_id: number;
            content: string;
            subject: string;
            to?: string;
            carbon_copy?: string;
            carbon_copy_invisible?: string;
        },
    ): CancelablePromise<MailTemplateCustomerResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/mailtemplatescustomer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Modeles d'e-mail personnalises d'une entreprise
     * Malgre le chemin `/{customer_id}`, ce n'est pas un enregistrement mais **la liste** des surcharges de l'entreprise, chacune avec le modele de reference. Tableau vide si aucune.
     * @param customerId
     * @returns MailTemplateCustomerResource Array of `MailTemplateCustomerResource`
     * @throws ApiError
     */
    public adminMailtemplatescustomerShow(
        customerId: string,
    ): CancelablePromise<Array<MailTemplateCustomerResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/mailtemplatescustomer/{customer_id}',
            path: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier une surcharge de modele d'e-mail
     * Mise a jour partielle.
     * @param id
     * @param requestBody
     * @returns MailTemplateCustomerResource `MailTemplateCustomerResource`
     * @throws ApiError
     */
    public adminMailtemplatescustomerUpdate(
        id: string,
        requestBody: {
            mail_template_id: number;
            customer_id: number;
            content: string;
            subject: string;
            to?: string;
            carbon_copy?: string;
            carbon_copy_invisible?: string;
        },
    ): CancelablePromise<MailTemplateCustomerResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/mailtemplatescustomer/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer une surcharge de modele d'e-mail
     * L'entreprise retrouve le modele par defaut.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminMailtemplatescustomerDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/mailtemplatescustomer/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
